import { Link } from "react-router-dom";
import type { NewsItem } from "@/types";
import { formatDate } from "@/utils/content";

export default function LatestNews({ items }: { items: NewsItem[] }) {
  return (
    <div className="flex flex-col divide-y divide-background-200">
      {items.map((item, i) => (
        <Link
          key={item.id}
          to={`/detail/${item.id}`}
          className="group flex cursor-pointer items-start gap-4 py-5 transition-colors md:gap-6"
        >
          <span className="flex w-10 shrink-0 flex-col items-center pt-0.5">
            <span className="font-heading text-xl font-bold text-primary-500">
              {String(i + 1).padStart(2, "0")}
            </span>
            <span className="mt-1 h-8 w-px bg-background-300" />
          </span>
          <div className="min-w-0 flex-1">
            <div className="flex flex-wrap items-center gap-3 text-xs text-foreground-500">
              <span className="rounded-full bg-primary-100 px-2.5 py-0.5 font-medium text-primary-700">
                {item.category}
              </span>
              <span className="flex items-center gap-1">
                <i className="ri-calendar-line" />
                {formatDate(item.date)}
              </span>
            </div>
            <h3 className="mt-2 font-heading text-base font-semibold leading-snug text-foreground-950 transition-colors group-hover:text-primary-600 md:text-lg">
              {item.title}
            </h3>
            <p className="mt-1.5 line-clamp-2 text-sm leading-relaxed text-foreground-600">
              {item.summary}
            </p>
          </div>
          <div className="hidden shrink-0 overflow-hidden rounded-md md:block" style={{ width: 132, height: 88 }}>
            <img
              src={item.image}
              alt={`${item.title} 缩略图`}
              title={`${item.title} - 风间由美资讯`}
              className="h-full w-full object-top transition-transform duration-500 group-hover:scale-105"
            />
          </div>
        </Link>
      ))}
    </div>
  );
}